import analytics, { EVENTS } from '@/services/analytics'

export function usePageView(options: {
  page_type: 'home' | 'listing' | 'detail' | 'onboarding' | 'checkout'
  product?: 'bonds' | 'fd' | 'mixed'
}) {
  onMounted(() => {
    analytics.track(EVENTS.PAGE_VIEWED, { ...options, user_type: 'anonymous' })
  })
}
